import React from 'react';

const AdminStudentsAll: React.FC = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-black dark:text-white">Manage All Students</h1>
      <p className="text-body">Placeholder for managing all student users system-wide.</p>
    </div>
  );
};

export default AdminStudentsAll;
